import script from "./DocumentFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentFiles.vue?vue&type=script&setup=true&lang=js"

import "./DocumentFiles.vue?vue&type=style&index=0&id=04e5dd4b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e5dd4b"]])

export default __exports__